import type { FormEvent } from "react";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import { RadioGroup } from "../basic/radioGroup";
import { LoginBackground } from "./background";

export enum MfaOption {
	Sms = 1,
	Email = 2,
	Phone = 3,
}

export interface MfaType {
	id: MfaOption;
	type: string;
	obfuscation: string;
}

interface Props {
	types: MfaType[];

	type: MfaOption;
	setType: (value: MfaOption) => void;

	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	goBack?: () => void;
	loading: boolean;
	disabled: boolean;
	version?: string;
	error?: string;

	logoImage?: string;
	backgroundImage?: string;
}

export function MfaTypePage(props: Props) {
	const {
		types,
		type,
		setType,
		submitFunction,
		goBack,
		loading,
		disabled,
		version,
		error,
		logoImage,
		backgroundImage,
	} = props;

	return (
		<LoginBackground
			title="Multi Factor Authentication"
			description="Where would you like to receive your multi-factor code?"
			version={version}
			logoImage={logoImage}
			backgroundImage={backgroundImage}
		>
			<form className="tw-grid tw-gap-4" onSubmit={submitFunction}>
				<div className="tw-flex tw-flex-col tw-justify-center tw-gap-2">
					<RadioGroup
						label="Multi Factor Type"
						value={type?.toString()}
						changeHandler={(val) => setType(parseInt(val) as MfaOption)}
						values={types.map((t) => ({
							id: t.id,
							value: `${t.type} (${t.obfuscation})`,
						}))}
					/>
				</div>

				{error !== undefined && <span className="tw-text-sm tw-text-red-400">{error}</span>}
				<Loading loading={loading} message="Sending code..." tag="h5">
					<Button type="submit" className="tw-w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Next
					</Button>
				</Loading>
				{goBack && (
					<Button className="tw-w-full" types={[ButtonTypes.Outline]} onClick={goBack}>
						Go Back
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
